<p>Market: {{marketType}} {{marketStatus}} Date: {{marketDate}}</p>
<p>market-info works!</p>
